import { Component, OnInit } from '@angular/core';
import {Router,ActivatedRoute,Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router'
import { MasterService,AttendanceService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-attcorrection',
  templateUrl: './attcorrection.component.html',
  styleUrls: ['./attcorrection.component.scss'],
  providers:[AttendanceService,MasterService]
})
export class AttcorrectionComponent implements OnInit {

  sections:any=[];
      tag:any;
      classes:any=[];
      attcordata:any=[];
      arrsubjects:any=[];
      fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0',atscope:'Individual',cbclid:'0'};
      attdata:any=[];
      attdatacmb:any=[];
      arrper:any=[];
      attcordetdata:any=[];
      arrcnmcls:any=[];
      arrcnmcls1:any=[];
      arrcourse:any=[];
      oprtype:any='';
      tabledata: any = {};
      objclass:any={};
      arrstulst:any=[];
      fmodel1:any={};
      cmodel:any={};
      cbmodel:any={};
      crpmodel:any={};
      objcbcl:any={};
      objvhead:any={};
      arrcmbdet:any=[];
      msgexist="";
      rmkh="";
      classeslist:any=[];
      corclasses:any=[];
      attcmbcordata:any=[];
      corsections:any=[];
      corsubjects:any=[];
      subjectslist:any=[];
      arrstaff:any=[];
      showload:any="no";
      showsms:any='no';
      arrbatch:any=[];
      modalOptions:NgbModalOptions;
      private modalRef: NgbModalRef;
      arratscope:any=[{name:'Individual'}];
      //arratscope:any=[{name:'Individual'}];
      arropt:any=[{name:'Yes'},{name:'No'}];
  
      dropdownList = [];
      selectedItems = [];
      dropdownSettings:IDropdownSettings = {singleSelection: false,
        idField: 'stuid',
        textField: 'stunm',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 0,
        allowSearchFilter: true};
   arflstudent: any;
   arreval: any;
   selstudent: any;
   objmnrts: any;
   arrcnmcls11: any;
  objath: any;
  tpid: any;
      constructor(private http: HttpClient,private aservice:AttendanceService, private mservice: MasterService,private modalService: NgbModal,private router: ActivatedRoute) { 
 
       // console.log(this.router.url);
       console.log(this.router.snapshot.url[0].path);
 // this.getmenuinfo(this.router.snapshot.url[0].path);
 //       router.events.subscribe((event: Event) => {
 //   console.log(event);
 //   if (event instanceof NavigationEnd ) {
 //     console.log(event.url);
 //   }
 // });
 
 
      }
    
       getmenuinfo(mid) {
     this.mservice.getmenuinfo(mid)
     .subscribe(
      resultArray =>
      { 
       console.log('menuinfo',resultArray);
       this.objmnrts=resultArray;
       this.mascourse();
        //this._postsArray = resultArray;
       // this.formatmenudata(resultArray);
    // console.log('menus',JSON.stringify(resultArray));
     }
 ,
      error => console.log("Error :: " + error)
  )
 }
      ngOnInit(): void {
       console.log("init called");
       this.getmenuinfo(this.router.snapshot.url[0].path);
        
        
        
    this.onclickcorrection();
       
      }
  
    
      opentest(content,obj) {
        debugger
        this.fmodel1.cbclid=obj.cbclid;
        this.selbatch();
        this.getstuforcmb();
        this.getattcmbdet(this.fmodel1.cbclid);
        this.modalOptions = {
          backdrop:'static',
          backdropClass:'customBackdrop',
          size:'lg'
          
         
        }
        this.modalRef=this.modalService.open(content,this.modalOptions);
        
        this.modalRef.result.then((result) => {
       
             
          }, (reason) => {
              
          });
      }
      
      addstudents()
      {
  
        console.log(this.selectedItems);
      }
    
      onscopechange()
      {
  
          this.combinedclass();
          this.SelectAttdDetails();
      }
    
      masclass() {
        this.mservice.classmasterrolewise(0,this.fmodel.crid,0,'class')
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.classes = resultArray;
                this.fmodel.clid=resultArray[0].clid;
                this.fmodel1.clid=resultArray[0].clid;
                this.cmodel.clid=resultArray[0].clid;
                this.massection();
                this.masperiod();
               // this.mascourse();
               
            },
            error => console.log("Error :: " + error)
            )
      }
  
      exportcolrpt(obj,tag)
  {
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.aservice.callurl+"export/expattcorlist.php?clcd="+clcd+"&aycd="+aycd+"&dtfrm="+obj.frdt+"&dtto="+obj.todt+"&clid="+obj.clid+"&scid="+obj.scid+"&crid="+obj.crid+"&chtype="+tag+"&suid="+obj.suid;
     console.log("url",url)
     window.open(url,'');
  
  }
  
      corclass(crid) {
        this.mservice.classmasterrolewise(0,crid,0,'class')
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.corclasses = resultArray;
                
                this.cmodel.clid=resultArray[0].clid;
                this.crpmodel.clid=resultArray[0].clid;
                this.corsection();
               // this.masperiod();
               // this.mascourse();
               
            },
            error => console.log("Error :: " + error)
            )
      }
  
  
      masperiod() {
        // this.mservice.masperiod(this.fmodel.clid)
        //     .subscribe(
        //     resultArray => {
        //         console.log('getdashcounts', resultArray);
        //         this.arrper = resultArray;
        //         this.fmodel.prid=resultArray[0].prid;
               
               
        //     },
        //     error => console.log("Error :: " + error)
        //     )
  
        this.mservice.masattperiod()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                var resultArray1=resultArray.filter(item=>item.active =='Yes');
                this.arrper = resultArray1;
                this.fmodel.prid=resultArray1[0].peid;
                this.fmodel.frtime=resultArray1[0].pesttime;
                this.fmodel.totime=resultArray1[0].peedtime;
               
            },
            error => console.log("Error :: " + error)
            )
      }
  
      onperiodchange()
      {
        debugger
        this.selstudent={};
        var peid=this.fmodel.prid;
  var pedet=this.arrper.filter(function (data) { return data.peid == peid });
  this.fmodel.frtime=pedet[0].pesttime;
  this.fmodel.totime=pedet[0].peedtime;
  this.SelectAttdDetails();
  
      }
  
      oncmbperiodchange()
      {
        debugger
        var peid=this.cbmodel.prid;
  var pedet=this.arrper.filter(function (data) { return data.peid == peid });
  this.cbmodel.frtime=pedet[0].pesttime;
  this.cbmodel.totime=pedet[0].peedtime;
  this.selectcombinedattendence();
  
      }
  
      oncmbclasschange()
      {
        debugger
        var clcbid=this.cbmodel.cbclid;
  var pedet=this.arrcnmcls1.filter(function (data) { return data.cbclid == clcbid });
  this.objcbcl=pedet[0];
  this.getobemtpmap1(this.objcbcl);
  this.selectcombinedattendence();
  // this.fmodel.totime=pedet[0].peedtime;
  // this.SelectAttdDetails();
  
      }
      massection() {
        this.mservice.sectionsrolewise(0,this.fmodel.crid,this.fmodel.clid,'section')
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.sections = resultArray;
                this.fmodel.secid=resultArray[0].scid;
                this.fmodel1.scid=resultArray[0].scid;
                this.fmodel.scid=resultArray[0].scid;
                this.subjects(this.fmodel.clid,this.fmodel.crid);
            },
            error => console.log("Error :: " + error)
            )
      }
  
      corsection() {
        this.mservice.sectionsrolewise(0,this.cmodel.crid,this.cmodel.clid,'section')
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.corsections = resultArray;
                
                this.cmodel.scid=resultArray[0].scid;
                this.corsubject(this.cmodel.clid,this.cmodel.crid);
            },
            error => console.log("Error :: " + error)
            )
      }
  
      mascourse() {
          this.mservice.mascourse()
              .subscribe(
              resultArray => {
                  console.log('getdashcounts', resultArray);
                  this.arrcourse = resultArray;
                  this.fmodel.crid=resultArray[0].crid;
                  this.fmodel1.crid=resultArray[0].crid;
                  this.cmodel.crid=resultArray[0].crid;
                  this.crpmodel.crid=resultArray[0].crid;
                  this.oncoursechange();
                  this.corclass(this.cmodel.crid);
              },
              error => console.log("Error :: " + error)
              )
        }
  
  
        getclasses() {
          debugger
          this.mservice.masclass()
              .subscribe(
              resultArray => {
                  console.log('getdashcounts', resultArray);
                  this.classeslist = resultArray;
                  this.objclass.clid=resultArray[0].clid;
                  this.subjectmas();
                  this.masperiod();
              },
              error => console.log("Error :: " + error)
              )
        }
  
  
        subjectmas() {
          this.mservice.sel_sp_massubjects()
              .subscribe(
              resultArray => {
                  console.log('getdashcounts', resultArray);
                  this.subjectslist = resultArray;
                  this.objclass.suid=resultArray[0].suid;
                  this.getobemtpmap1(this.objclass);
                  this.getstafflist();
              },
              error => console.log("Error :: " + error)
              )
        }
  
         
      getstafflist() {
        this.mservice.staffrolewise()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
               // resultArray.shift();
                this.arrstaff = resultArray;
               
                this.objclass.emid=resultArray[0].emid;
                 this.oncmbclasschange();
                //this.SelectAttdcorDetails();
            },
            error => console.log("Error :: " + error)
            )
      }
  
      combinedclass() {
        debugger
          this.mservice.combinedclass()
              .subscribe(
              resultArray => {
                  console.log('getdashcounts', resultArray);
                  if (resultArray != undefined)
                  {
                  this.arrcnmcls = resultArray;
                  this.fmodel.cbclid=resultArray[0].cbclid;
                  this.crpmodel.cbclid=resultArray[0].cbclid;
                  this.cbmodel.cbclid=resultArray[0].cbclid;
                  }
                 // this.oncmbclasschange();
                  this.getclasses();
                  // this.masperiod();
              },
              error => console.log("Error :: " + error)
              )
        }
 
         combinedclass1() {
        debugger
          this.mservice.combinedclass()
              .subscribe(
              resultArray => {
                  console.log('getdashcounts', resultArray);
                  if (resultArray != undefined)
                  {
                  this.arrcnmcls11 = resultArray;
                 //  this.fmodel.cbclid=resultArray[0].cbclid;
                 //  this.crpmodel.cbclid=resultArray[0].cbclid;
                 //  this.cbmodel.cbclid=resultArray[0].cbclid;
                  }
                 // this.oncmbclasschange();
                 //  this.getclasses();
                  // this.masperiod();
              },
              error => console.log("Error :: " + error)
              )
        }
  
  
        attcombinedclass() {
         this.selstudent={};
          this.mservice.attcombinedclass()
              .subscribe(
              resultArray => {
                  console.log('getdashcounts', resultArray);
                  this.arrcnmcls1 = resultArray;
                 // this.fmodel.cbclid=resultArray[0].cbclid;
                  this.crpmodel.cbclid=resultArray[0].cbclid;
                  this.cbmodel.cbclid=resultArray[0].cbclid;
                   this.getclasses();
                 
                 
              },
              error => console.log("Error :: " + error)
              )
        }
  
      subjects(clid,crid) {
          this.mservice.subjectsrolewise(0,0,clid,'asaa',crid)
              .subscribe(
              resultArray => {
                  console.log('getdashcounts', resultArray);
                  this.arrsubjects = resultArray;
                  this.corsubjects = resultArray;
                  this.fmodel.subid=resultArray[0].suid;
                 // this.cmodel.suid=resultArray[0].suid;
                  this.getobemtpmap(this.fmodel);
                  this.SelectAttdDetails();
                 
              },
              error => console.log("Error :: " + error)
              )
        }
        corsubject(clid,crid) {
          this.mservice.subjectsrolewise(0,0,clid,'asaa',crid)
              .subscribe(
              resultArray => {
                  console.log('getdashcounts', resultArray);
                 
                  this.corsubjects = resultArray;
                 
                  this.cmodel.suid=resultArray[0].suid;
                  this.crpmodel.suid=resultArray[0].suid;
                  this.SelectAttdcorDetails();
              },
              error => console.log("Error :: " + error)
              )
        }
        oncoursechange()
        {
  
          this.masclass();
          //this.subjects(this.fmodel.clid,this.fmodel.crid);
  this.SelectAttdDetails();
        }
  
        onclasschange()
        {
          this.massection();
  this.masperiod();
  //this.subjects(this.fmodel.clid,this.fmodel.crid);
  this.SelectAttdDetails();
  
        }
  
        SelectAttdcorDetails() {
  
          console.log('pstdat',this.cmodel);
 
         // this.getobemtpmap(this.cmodel);
  
          this.aservice.getattsumper(this.cmodel)
          .subscribe(resultArray => {
              console.log('ret-by-atd', resultArray);
              this.attcordata = resultArray;
  
              //alert(resultArray.message);
  
          }, error =>
              alert('error in connection')
          );
        }
  
        
        SelectAttdcorcmbDetails() {
  
         //  console.log('pstdat',this.cmodel);
         // this.getobemtpmap1(this.crpmodel);
  
          this.aservice.getattsumpercmb(this.crpmodel)
          .subscribe(resultArray => {
              console.log('ret-by-atd', resultArray);
              this.attcmbcordata = resultArray;
  
              //alert(resultArray.message);
  
          }, error =>
              alert('error in connection')
          );
        }
  
        getattdetails() {
  
          console.log('pstdat',this.objvhead);
  
          this.aservice.getattdet(this.objvhead)
          .subscribe(resultArray => {
              console.log('ret-by-atd', resultArray);
              this.attcordetdata = resultArray;
  
              //alert(resultArray.message);
  
          }, error =>
              alert('error in connection')
          );
        }
  
        openmdldetmain(content,objdata,tag) {
          debugger
          this.tag=tag;
            this.objvhead=objdata;
            this.rmkh=objdata.rmkh;
          
            this.getattdetails();
            this.modalOptions = {
              backdrop:'static',
              backdropClass:'customBackdrop',
              size:'lg'
             
            }
            this.modalRef=this.modalService.open(content,this.modalOptions);
            
            this.modalRef.result.then((result) => {
           
                 
              }, (reason) => {
                  
              });
          }
          
    
      SelectAttdDetails() {
        debugger
        this.getobemtpmap(this.fmodel);
        var clid = this.fmodel.clid;
        var secid = this.fmodel.secid;
        var attdt = this.fmodel.attdt;
        var cbclid = this.fmodel.cbclid;
        var crid = this.fmodel.crid;
        var atscope=this.fmodel.atscope;
        let clcd=localStorage.getItem('clcd');
        let aycd=localStorage.getItem('aycd');
        var oprtype=";"
        if(atscope=='Individual')
        {
           oprtype="selattperind";
        }
        else if (atscope=='Combined')
        {
           oprtype="selattpercmb";
          // clid = this.fmodel.cbclid;
        }
        
        var asgnmtdata = { clid: clid, secid: secid, attdt: attdt,cbclid:cbclid,atscope:atscope,oprtype:oprtype,clcd:clcd,aycd:aycd,prid:this.fmodel.prid,subid:this.fmodel.subid ,crid:crid};
        console.log('model-by', asgnmtdata);
        this.aservice.by_sp_clmattendanceperiod(asgnmtdata)
            .subscribe(resultArray => {
                console.log('ret-by-atd', resultArray);
    //alert(resultArray.length);
                if (resultArray.byclmattendanceper.length>0)
                {
    //alert("Attendance already marked for this period");
                   // alert('1');
                   this.showsms='yes';
                   var subnm='';
                   if(resultArray.objrmk != '')
                   {
                   subnm=resultArray.objrmk.sunm;
                   // this.rmkh=resultArray.objrmk.tpid;
                   this.onmemberChangeSearch(resultArray.objrmk.tpnm);
                   this.selstudent=  this.arflstudent[0];
                   }
                   else
                     {
                    subnm="";
                    this.rmkh="";
                   }
                   this.msgexist=subnm+" Attendance already marked for this period";
                this.attdata = resultArray.byclmattendanceper;
                if(atscope=='Individual')
                {
                this.oprtype="updattperindtp";
                }
                else
                {
                  this.oprtype="updattpercmbtp";
                }
                }
    
                else{
                  //  alert('2');
                  this.showsms='no';
                  this.msgexist="";
                  this.rmkh="";
                  if(atscope=='Individual')
                {
                this.oprtype="insattperindtp";
                }
                else
                {
                  this.oprtype="insattpercmbtp";
                }
                    this.SelectAttdDtlsifnotavail();
                    
                }
                //alert(resultArray.message);
    
            }, error =>
                alert('error in connection')
            );
    }
    
  
    selectcombinedattendence() {
      debugger
      var clid = this.objcbcl.clid;
      var secid = 0;
      var attdt = this.cbmodel.attdt;
      var cbclid = this.cbmodel.cbclid;
      var crid = 0;
      var atscope="Combined";
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      var oprtype=";"
      
         oprtype="selattpercmb";
     
      
      var asgnmtdata = { clid: clid, secid: secid, attdt: attdt,cbclid:cbclid,atscope:atscope,oprtype:oprtype,clcd:clcd,aycd:aycd,prid:this.cbmodel.prid,subid:this.objcbcl.suid ,crid:crid};
      console.log('model-by', asgnmtdata);
      this.aservice.by_sp_clmattendanceperiod(asgnmtdata)
          .subscribe(resultArray => {
              console.log('ret-by-atd', resultArray);
  //alert(resultArray.length);
  if (resultArray.byclmattendanceper.length>0)
  {
  //alert("Attendance already marked for this period");
     // alert('1');
     this.showsms='yes';
     var subnm='';
     if(resultArray.objrmk != '')
     {
     subnm=resultArray.objrmk.sunm;
     this.onmemberChangeSearch(resultArray.objrmk.tpnm);
                   this.selstudent=  this.arflstudent[0];
     }
     else{
      subnm="";
      this.rmkh="";
     }
     this.msgexist=subnm+" Attendance already marked for this period";
              this.attdatacmb = resultArray.byclmattendanceper;
             
                this.oprtype="updattpercmbtp";
              
              }
  
              else{
                //  alert('2');
                this.showsms='no';
                this.msgexist="";
                this.rmkh="";
              
                this.oprtype="insattpercmbtp";
          
                  this.SelectcmbAttdDtlsifnotavail();
                  
              }
              //alert(resultArray.message);
  
          }, error =>
              alert('error in connection')
          );
  }
  
    onclickcorrection()
    {
  
      this.cmodel.frdt=this.aservice.getdatetoday();
      this.cmodel.todt=this.aservice.getdatetoday();
      this.mascourse();
    }
  
  
    onclickcmbcorrection()
    {
  
      this.crpmodel.frdt=this.mservice.getdatetoday();
      this.crpmodel.todt=this.mservice.getdatetoday();
      this.corclass(this.crpmodel.crid);
    }
  
  
    sendmarks()
    {
     this.showload="yes";
      var stulst=this.attdata.filter(item => item.s1===false);
  
     var stulst1= stulst.map(item => {
        
        
        
        return item.stuid;
       });
     // console.log('assid1',this.arrevpatern);
      console.log('assid2',stulst);
     // console.log('assid',this.asmtid);
      var postdata={atdt:this.fmodel.attdt,stulst:stulst1,tag:'comp',frtm:this.fmodel.frtime,totm:this.fmodel.totime,suid:this.fmodel.subid};
      console.log('postdata',postdata);
      this.aservice.sendsmspr(postdata)
      .subscribe(
      resultArray => {
          console.log('stulst', resultArray);
          alert(resultArray.message);
         this.showload="no";
          
         
      },
      error =>{ console.log("Error :: " + JSON.stringify(error));
      alert("Error in sending sms");
      this.showload="no";
    }
      )
    }
    
    Savecordetails() {
      console.log('obj',this.objvhead);
  
      this.tabledata.dbnm = '';
      this.tabledata.oprtag="updattperind";
      this.tabledata.attdt = this.objvhead.atdt;
      this.tabledata.clid = this.cmodel.clid;
      this.tabledata.secid = this.cmodel.scid;
      this.tabledata.prid = this.objvhead.peid;
      this.tabledata.subid = this.cmodel.suid;
      this.tabledata.frtime = "";
      this.tabledata.totime = "";
      this.tabledata.crid = this.cmodel.crid;
      this.tabledata.atscope = "";
      this.tabledata.rmkh = this.rmkh;
      this.tabledata.clcd=localStorage.getItem('clcd');
      this.tabledata.aycd=localStorage.getItem('aycd');
    
      var arrattendance=this.attcordetdata.map(item => {
          if (item.s1 == false){
             item.s1=0;
           }
           else{
            item.s1=1;
           }
      
          
          
          return item;
         });
      
        
         this.tabledata.loopdata = arrattendance;
      console.log('attendance-data', this.tabledata);
      this.aservice.loop_clmattendanceperiod(this.tabledata)
           .subscribe(resultArray => {
              console.log('ret-loop', resultArray);
    
              alert(resultArray.message);
          }, error =>
              alert('error in connection')
          );
    }
  
    Savecomcordetails() {
      debugger
      console.log('obj',this.objvhead);
  
      this.tabledata.dbnm = '';
      this.tabledata.oprtag="updattpercmb";
      this.tabledata.attdt = this.objvhead.atdt;
      this.tabledata.clid = this.cmodel.clid;
      this.tabledata.cbclid = this.objvhead.cbclid;
      this.tabledata.secid = this.cmodel.scid;
      this.tabledata.prid = this.objvhead.peid;
      this.tabledata.subid = this.cmodel.suid;
      this.tabledata.frtime = "";
      this.tabledata.totime = "";
      this.tabledata.crid = this.cmodel.crid;
      this.tabledata.atscope = "";
      this.tabledata.rmkh = this.rmkh;
      this.tabledata.clcd=localStorage.getItem('clcd');
      this.tabledata.aycd=localStorage.getItem('aycd');
    
      var arrattendance=this.attcordetdata.map(item => {
          if (item.s1 == false){
             item.s1=0;
           }
           else{
            item.s1=1;
           }
      
          
          
          return item;
         });
      
        
         this.tabledata.loopdata = arrattendance;
      console.log('attendance-data', this.tabledata);
      this.aservice.loop_clmattendanceperiod(this.tabledata)
           .subscribe(resultArray => {
              console.log('ret-loop', resultArray);
    
              alert(resultArray.message);
          }, error =>
              alert('error in connection')
          );
    }
  
    Savedetails() {
      debugger
     // console.log('testdata', this.dataSource.data);
      
      this.tabledata.dbnm = '';
      this.tabledata.oprtag=this.oprtype;
      this.tabledata.attdt = this.fmodel.attdt;
  
      if( this.fmodel.atscope=='Combined')
      {
      this.tabledata.cbclid = this.fmodel.cbclid;
      this.tabledata.clid = this.fmodel.clid;
      }
      else{
        this.tabledata.cbclid = '0';
        this.tabledata.clid = this.fmodel.clid;
      }
      this.tabledata.secid = this.fmodel.secid;
      this.tabledata.prid = this.fmodel.prid;
      this.tabledata.subid = this.fmodel.subid;
      this.tabledata.frtime = this.fmodel.frtime;
      this.tabledata.totime = this.fmodel.totime;
      this.tabledata.crid = this.fmodel.crid;
      this.tabledata.atscope = this.fmodel.atscope;
      this.tabledata.rmkh = this.rmkh;
      this.tabledata.clcd=localStorage.getItem('clcd');
      this.tabledata.aycd=localStorage.getItem('aycd');
    
      var arrattendance=this.attdata.map(item => {
          if (item.s1 == false){
             item.s1=0;
           }
           else{
            item.s1=1;
           }
      
          
          
          return item;
         });
      
        
         this.tabledata.loopdata = arrattendance;
      console.log('attendance-data', this.tabledata);
      this.aservice.loop_clmattendanceperiod(this.tabledata)
           .subscribe(resultArray => {
              console.log('ret-loop', resultArray);
    
              alert(resultArray.message);
              this.selstudent={};
              this.SelectAttdDetails();
          }, error =>
              alert('error in connection')
          );
    }
    
    Savecmbclassdetails() {
      debugger
     // console.log('testdata', this.dataSource.data);
      
      this.tabledata.dbnm = '';
      this.tabledata.oprtag=this.oprtype;
      this.tabledata.attdt = this.cbmodel.attdt;
  
     
      this.tabledata.cbclid = this.cbmodel.cbclid;
      this.tabledata.clid = this.objcbcl.clid;
      
     
      this.tabledata.secid = 1;
      this.tabledata.prid = this.cbmodel.prid;
      this.tabledata.subid = this.objcbcl.suid;
      this.tabledata.frtime = this.cbmodel.frtime;
      this.tabledata.totime = this.cbmodel.totime;
      this.tabledata.crid = 0;
      this.tabledata.atscope = "Combined";
      this.tabledata.clcd=localStorage.getItem('clcd');
      this.tabledata.aycd=localStorage.getItem('aycd');
      this.tabledata.rmkh = this.rmkh;
    
      var arrattendance=this.attdatacmb.map(item => {
          if (item.s1 == false){
             item.s1=0;
           }
           else{
            item.s1=1;
           }
      
          
          
          return item;
         });
      
        
         this.tabledata.loopdata = arrattendance;
      console.log('attendance-data', this.tabledata);
      this.aservice.loop_clmattendanceperiod(this.tabledata)
           .subscribe(resultArray => {
              console.log('ret-loop', resultArray);
    
              alert(resultArray.message);
              this.selstudent={};
              this.selectcombinedattendence();
          }, error =>
              alert('error in connection')
          );
    }
    
    SelectcmbAttdDtlsifnotavail() {
      debugger
      var clid = this.objcbcl.clid;
      var secid = 0;
      var attdt = this.cbmodel.attdt;
      var cbclid = this.cbmodel.cbclid;
      var crid = 0;
      var atscope="Combined";
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      var oprtype=";"
   
         oprtype="selstupercmb";
       
      
      
      var asgnmtdata = { clid: clid, secid: secid,cbclid:cbclid, attdt: attdt,oprtype:oprtype,clcd:clcd,aycd:aycd,prid:this.cbmodel.prid,subid:this.objcbcl.suid,crid:crid };
    //  var asgnmtdata = { clid: clid, secid: secid, attdt: attdt,seltag:'selstubyclid',clcd:clcd,aycd:aycd };
      console.log('model-by', asgnmtdata);
      this.aservice.by_sp_clmattendanceperiod(asgnmtdata)
          .subscribe(resultArray => {
              console.log('ret-by-atd', resultArray);
              this.attdatacmb = resultArray.byclmattendanceper;
  
              //alert(resultArray.message);
  
          }, error =>
              alert('error in connection')
          );
  }
  
  
    SelectAttdDtlsifnotavail() {
        debugger
        var clid = this.fmodel.clid;
        var secid = this.fmodel.secid;
        var attdt = this.fmodel.attdt;
        var cbclid = this.fmodel.cbclid;
        var crid = this.fmodel.crid;
        var atscope=this.fmodel.atscope;
        let clcd=localStorage.getItem('clcd');
        let aycd=localStorage.getItem('aycd');
        var oprtype=";"
        if(atscope=='Individual')
        {
           oprtype="selstuperind";
        }
        else if (atscope=='Combined')
        {
           oprtype="selstupercmb";
          // clid = this.fmodel.cbclid;
        }
        
        
        var asgnmtdata = { clid: clid, secid: secid,cbclid:cbclid, attdt: attdt,oprtype:oprtype,clcd:clcd,aycd:aycd,prid:this.fmodel.prid,subid:this.fmodel.subid,crid:crid };
      //  var asgnmtdata = { clid: clid, secid: secid, attdt: attdt,seltag:'selstubyclid',clcd:clcd,aycd:aycd };
        console.log('model-by', asgnmtdata);
        this.aservice.by_sp_clmattendanceperiod(asgnmtdata)
            .subscribe(resultArray => {
                console.log('ret-by-atd', resultArray);
                this.attdata = resultArray.byclmattendanceper;
    
                //alert(resultArray.message);
    
            }, error =>
                alert('error in connection')
            );
    }
    
    deleteattend(atid,tag) {
      debugger
     // console.log('testdata', this.dataSource.data);
      if(confirm("Are you sure you wan't to delete ?"))
      {
     var pst={atid:atid};
      this.aservice.deleteattendance(pst)
           .subscribe(resultArray => {
              console.log('ret-loop', resultArray);
    
              alert(resultArray.message);
              if(tag=="ind")
              {
              this.SelectAttdcorDetails();
              }
              else{
                this.SelectAttdcorcmbDetails();
              }
          }, error =>
              alert('error in connection')
          );
        }
    }
    
  
    openclass(content,objdata,cmd) {
  
      
      if(cmd=='insclh')
      {
        this.objclass={};
       
        
        this.objclass.cbclid=0;
        this.objclass.cbclcd='';
        this.objclass.cbclnm='';
        this.objclass.active='Yes';
        this.objclass.oprtype='insclh';
       
  
      }
  
      else if(cmd=='updclh')
      {
        this.objclass=objdata;
        this.objclass.oprtype='updclh';
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'lg'
       
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }
    
  
    saveclassdetails()
    {
  
  
      console.log('savedetails',this.objclass);
      this.mservice.savecmbclass(this.objclass)
  .subscribe(result => {
     alert(result.message);
     
  if(result.status=='Success')
  {
    let localmodref=this.modalRef;
  localmodref.close();
  //this.Refreshsummary();
  this.combinedclass();
  
  }
  
  
  else{
  
  
  }
     
  
    
      
  }, error => alert('error in connection')
  );
    }
  
    getstuforcmb() {
      this.mservice.getstuforcmb(this.fmodel1)
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrstulst = resultArray.arrstulst;
              // this.fmodel.cbclid=resultArray[0].cbclid;
          },
          error => console.log("Error :: " + error)
          )
    }
  
    selbatch()
  {
    debugger
    this.mservice.selbatch()
    .subscribe(
    resultArray =>{
      //console.log('sub-result', resultArray);
      this.arrbatch=resultArray;
      this.fmodel1.baid=resultArray[0].baid;
      //this.objfilt.baid=resultArray[0].baid;
      },
  error => console.log("Error :: " + error)
  )
  }
    savecbmclassd() {
      debugger
     
      this.aservice.savecbmclassd(this.fmodel1,this.selectedItems)
           .subscribe(resultArray => {
              console.log('ret-loop', resultArray);
    //var cbclid=this.fmodel1,cbclid
              alert(resultArray.message);
              if(resultArray.status=='Success')
              {
                this.getattcmbdet(this.fmodel1.cbclid);
              this.getstuforcmb();
              this.selectedItems=[];
              }
          }, error =>
              alert('error in connection')
          );
    }
  
    getattcmbdet(cbclid) {
      this.aservice.getattcmbdet(cbclid)
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrcmbdet = resultArray;
              
          },
          error => console.log("Error :: " + error)
          )
    }
  
    delcbmclassd(rid) {
      debugger
     
      if (confirm("Are you sure you want to delete ?"))
      this.aservice.delcbmclassd(rid)
           .subscribe(resultArray => {
              console.log('ret-loop', resultArray);
    //var cbclid=this.fmodel1,cbclid
              alert(resultArray.message);
              if(resultArray.status=='Success')
              {
                this.getattcmbdet(this.fmodel1.cbclid);
              this.getstuforcmb();
              this.selectedItems=[];
              }
          }, error =>
              alert('error in connection')
          );
    }
 
 
           getobemtpmap(obj) {
           this.mservice.getobemtpmap1(obj)
               .subscribe(
               resultArray => {
                   console.log('getdashcounts', resultArray);
                   this.arreval = resultArray;
                  
               },
               error => console.log("Error :: " + error)
               )
         }


         
   openatth(content,objdata,cmd) {
 
     this.getobemtpmap1(objdata);
  
 
     
       this.objath=objdata;
      //  this.onmemberChangeSearch(objdata.tpnm);
      //             this.selstudent=  this.arflstudent[0];
      //  this.tpid=objdata.tpid;
       this.objath.oprtype=cmd //'';
    
     
     this.modalOptions = {
       backdrop:'static',
       backdropClass:'customBackdrop',
       size:'md'
      
      
     }
     this.modalRef=this.modalService.open(content,this.modalOptions);
     
     this.modalRef.result.then((result) => {
    
          
       }, (reason) => {
           
       });
   }

   saveatthdetails()
   {

    var pst={tpid:this.tpid,rmkh:this.objath.rmkh,atdt:this.objath.atdt,pesttime:this.objath.pesttime,peedtime:this.objath.peedtime,atid:this.objath.atid,oprtype:this.objath.oprtype};
    console.log('objath',pst);
    this.aservice.saveatthcordetails(pst)
         .subscribe(resultArray => {
            console.log('ret-loop', resultArray);
            alert(resultArray.message);
             this.selstudent={};
             let localmodref=this.modalRef;
localmodref.close();
if(this.objath.oprtype=='updattpercmbtph')
{
this.SelectAttdcorcmbDetails();
}

else 
{
this.SelectAttdcorDetails();
}
   }, error =>
             alert('error in connection')
         );
        }
 
         getobemtpmap1(obj) {
           debugger
          //  obj.crid="0";
           this.mservice.getobemtpmap(obj)
               .subscribe(
               resultArray => {
                   console.log('getdashcounts', resultArray);
                   this.arreval = resultArray;
                   if(resultArray.length>0)
                   {
                    this.onmemberChangeSearch(obj.tpnm);
                  this.selstudent=  this.arflstudent[0];
                   }
                  
               },
               error => console.log("Error :: " + error)
               )
         }
 
     onmemberselectEvent(item) {
 //alert('hi');
     console.log('item',item);
     // this.objlevel.duration=item.duration;
     this.tpid=item.tpid;
    }
         onmemberChangeSearch(sertxt) {
     debugger
   
 
   
 
   this.arflstudent= this.arreval.filter(item => {
       
       const nameMatches = item.tpnm.toLowerCase().includes(sertxt.toLowerCase());
      
       return nameMatches ; 
     });
     console.log('arflstudent',this.arflstudent);
   }
  
   onDropDownClick(event: any) {
     this.arflstudent = this.arreval; // Show the full list
 
     // Manually toggle the dropdown visibility if needed, as default behavior can vary
     event.originalEvent.preventDefault();
     event.originalEvent.stopPropagation();
 
     // if (this.autoCompleteComponent.overlayVisible) {
     //   this.autoCompleteComponent.hide();
     // } else {
     //   this.autoCompleteComponent.show();
     // }
   }
        
    }
  
